function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "A",
  x2: 64,
  y1: -21.333,
  y2: 85.333,
  gradientTransform: "matrix(.26458 0 0 .26458 207.49 174.44)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2383ae",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6dd7b9",
  offset: 1
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-207.49 -177.82)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m211.72 181.21c0.56436-2.2577 1.9756-3.3867 4.2333-3.3867 3.3867 0 3.81 2.54 5.5033 2.9633 1.129 0.28231 2.1167-0.14102 2.9633-1.27-0.56434 2.2577-1.9756 3.3867-4.2333 3.3867-3.3867 0-3.81-2.54-5.5033-2.9633-1.129-0.28231-2.1167 0.14103-2.9633 1.27zm-4.2333 5.08c0.56436-2.2577 1.9756-3.3867 4.2333-3.3867 3.3867 0 3.81 2.54 5.5033 2.9633 1.129 0.28231 2.1167-0.14102 2.9633-1.27-0.56435 2.2577-1.9756 3.3867-4.2333 3.3867-3.3867 0-3.81-2.54-5.5034-2.9633-1.129-0.28231-2.1167 0.14103-2.9633 1.27z",
  fill: "url(#A)",
  fillRule: "evenodd",
  strokeWidth: 0.26458
}));

function SvgTailwind(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16.933mm",
    height: "10.16mm",
    viewBox: "0 0 16.933 10.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwind);
export default __webpack_public_path__ + "static/media/tailwind.0f4c44b9.svg";
export { ForwardRef as ReactComponent };